import { useState } from 'react'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useLocation } from 'react-router-dom'

export default function ImageWithSkeleton ({ src, ratio, square, maxWidth, oneSize, imageSx = {} }) {
  const [imageLoaded, setImageLoaded] = useState(false)
  const isSmallScreen = useMediaQuery('(max-width:600px)')
  const location = useLocation()

  // Add "-2x" to the filename for CloudFront CDN images on larger screens when
  // pathname contains '/races/'. Other hosts (e.g. Cloudinary) must be passed
  // through unchanged since they have no "-2x" variant.
  const isCdnImage = src.startsWith('https://d1hi0tbu2kom2c.cloudfront.net/')
  const modifiedSrc = !oneSize && !isSmallScreen && isCdnImage && location.pathname.includes('/races/')
    ? src.replace(/(\.[\w\d]+)$/, '-2x$1')
    : src

  return (
    <>
      {!imageLoaded && (
        <Skeleton
          variant='rectangular'
          sx={{
            maxWidth: maxWidth || 'unset',
            width: '100%',
            paddingTop: ratio ? `${100 / ratio}%` : 'default',
            borderRadius: square ? 0 : 2
          }}
        />
      )}
      <Box
        component='img'
        src={modifiedSrc}
        sx={{
          ...imageSx,
          maxWidth: maxWidth || 'unset',
          width: '100%',
          borderRadius: square ? 0 : 2,
          display: imageLoaded ? 'block' : 'none'
        }}
        onLoad={() => setImageLoaded(true)}
      />
    </>
  )
}
